var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DaDataInput',{attrs:{"name":"company","input-name":'company',"set-label":(item) => {
			if (item.value) {
				return `${item.value}`
			}
			return `${item}`;
		},"da-data-item":_vm.DaDataCompanyItem,"initial-value":_vm.value,"input-options":_vm.inputOptions,"style-classes":_vm.styleClasses,"suggest-type":'party',"is-set-initial-value":true,"is-own-type-value":true},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }